import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { AuthWrapperComponent } from '@shared/auth-wrapper/auth-wrapper.component';

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AuthWrapperComponent]
})
export class AccessDeniedComponent implements OnInit {
    constructor(
        private readonly router: Router,
        private readonly authService: AuthService
    ) {}

    ngOnInit(): void {
        this.authService.redirectIfAuthenticated();
    }

    onGoBack(event: Event): void {
        event.preventDefault();
        this.router.navigate(['/login']);
    }
}
